import React from 'react'
import { FormattedMessage } from 'react-intl'

import OwnerCanConfirmAdjustmentsFooter from './owner-can-confirm-adjustments/owner-can-confirm-adjustments-footer/OwnerCanConfirmAdjustmentsFooter'
import OwnerCanConfirmBookingFooter from './owner-can-confirm-booking/owner-can-confirm-booking-footer/OwnerCanConfirmBookingFooter'
import OwnerCanConfirmQuotationFooter from './owner-can-confirm-quotation-footer/OwnerCanConfirmQuotationFooter'
import OwnerCanReUploadQuotationFooter from './owner-can-re-upload-quotation-footer/OwnerCanReUploadQuotationFooter'
import OwnerCanUploadQuotationFooter from './owner-can-upload-quotation-footer/OwnerCanUploadQuotationFooter'
import OwnerWaitingUserBookingConfirmationFooter from './owner-waiting-user-booking-confirmation-footer/OwnerWaitingUserBookingConfirmationFooter'
import OwnerCurrentActionFooterContainer from './OwnerCurrentActionFooterContainer'
import { IUploadQuotationProps } from './upload-quotation-modal/UploadQuotationModal'
import {
  ClientProposalOwnerActionEnum,
  CompanyInformationClientRequestFragment,
} from '../../../../../../lib/graphql'
import { Button } from '../../../../../../shadcn/components/ui/button'
import { openHubSpotChat } from '../../../../../../utils'
import { IProposalInteractionsProps } from '../../../../../organisms/proposal/Proposal'
import PingPongButton from '../../../../../organisms/proposal/proposal-cta/buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../../../../organisms/proposal/proposal-cta/utils/ping-pong-button-type.enum.ts'

const OwnerCurrentAction = ({
  ownerActions,
  uploadQuotationData,
  clientRequest,
}: {
  ownerActions: IProposalInteractionsProps['ownerActions']
  uploadQuotationData?: IUploadQuotationProps
  clientRequest: CompanyInformationClientRequestFragment
}) => {
  const clientProposal = clientRequest.clientProposal
  const ownerCurrentAction = clientProposal?.ownerCurrentAction

  if (!clientProposal) {
    return null
  }

  switch (ownerCurrentAction) {
    case ClientProposalOwnerActionEnum.CLIENT_REQUEST_CANCELLED:
      return (
        <OwnerCurrentActionFooterContainer>
          <Button disabled={true} variant='ghost' className='w-full'>
            <FormattedMessage
              id='ui.ownerCurrentAction.clientRequestCancelled.button.label'
              defaultMessage='Événement annulé'
            />
          </Button>
        </OwnerCurrentActionFooterContainer>
      )
    case ClientProposalOwnerActionEnum.CAN_CONFIRM_QUOTATION:
      return (
        <OwnerCanConfirmQuotationFooter
          clientProposal={clientProposal}
          ownerActions={ownerActions}
          uploadQuotationData={uploadQuotationData}
        />
      )
    case ClientProposalOwnerActionEnum.BOOKING_DECLINED_BY_HOST:
      return (
        <OwnerCurrentActionFooterContainer>
          <Button disabled={true}>
            <FormattedMessage
              id='ui.ownerCurrentAction.bookingDeclinedByHost.button.label'
              defaultMessage='Vous avez refusé la réservation'
            />
          </Button>
        </OwnerCurrentActionFooterContainer>
      )
    case ClientProposalOwnerActionEnum.LOST:
      return (
        <OwnerCurrentActionFooterContainer>
          <Button disabled={true}>
            <FormattedMessage
              id='ui.ownerCurrentAction.lost.button.label'
              defaultMessage='Réservation perdue'
            />
          </Button>
        </OwnerCurrentActionFooterContainer>
      )
    case ClientProposalOwnerActionEnum.BOOKING_DECLINED_BY_USER_ADMIN:
      return (
        <OwnerCurrentActionFooterContainer>
          <PingPongButton
            label={
              <FormattedMessage
                id='ui.ownerCurrentAction.bookingDeclinedByUserAdmin.button.label'
                defaultMessage='Devis non compatible : contacter un conseiller'
              />
            }
            type={PingPongButtonTypeEnum.CONTACT_ADMIN}
            onClick={openHubSpotChat}
          />
        </OwnerCurrentActionFooterContainer>
      )
    case ClientProposalOwnerActionEnum.CAN_RE_UPLOAD_QUOTATION:
      return (
        <OwnerCanReUploadQuotationFooter
          clientProposal={clientProposal}
          uploadQuotationData={uploadQuotationData}
          ownerActions={ownerActions}
        />
      )
    case ClientProposalOwnerActionEnum.WAITING_USER_BOOKING_CONFIRMATION:
      return (
        <OwnerWaitingUserBookingConfirmationFooter
          ownerActions={ownerActions}
        />
      )
    case ClientProposalOwnerActionEnum.CAN_UPLOAD_QUOTATION:
      return (
        <OwnerCanUploadQuotationFooter
          clientProposal={clientProposal}
          uploadQuotationData={uploadQuotationData}
          ownerActions={ownerActions}
        />
      )
    case ClientProposalOwnerActionEnum.CAN_CONFIRM_BOOKING:
      return (
        <OwnerCanConfirmBookingFooter
          ownerActions={ownerActions}
          clientProposal={clientProposal}
        />
      )
    case ClientProposalOwnerActionEnum.WAITING_USER_PAY_DEPOSIT:
      return (
        <OwnerCurrentActionFooterContainer>
          <PingPongButton
            dataTestId='waiting-user-deposit-button'
            label={
              <FormattedMessage
                id='ui.ownerCurrentAction.waitingUserPayDeposit.button.label'
                defaultMessage="Attente du règlement de l'acompte"
              />
            }
            type={PingPongButtonTypeEnum.WAITING}
          />
        </OwnerCurrentActionFooterContainer>
      )
    case ClientProposalOwnerActionEnum.DEPOSIT_PAID:
      return (
        <OwnerCurrentActionFooterContainer>
          <PingPongButton
            label={
              <FormattedMessage
                id='ui.ownerCurrentAction.depositPaid.button.label'
                defaultMessage='Acompte réglé'
              />
            }
            type={PingPongButtonTypeEnum.PAYMENT_DONE}
          />
        </OwnerCurrentActionFooterContainer>
      )
    case ClientProposalOwnerActionEnum.CAN_CONFIRM_ADJUSTMENTS:
      return (
        <OwnerCanConfirmAdjustmentsFooter
          ownerActions={ownerActions}
          clientProposalId={clientProposal._id}
          ownerAskedAdjustmentsModificationAt={
            clientProposal.ownerAskedAdjustmentsModificationAt
          }
        />
      )
    case ClientProposalOwnerActionEnum.ADJUSTMENTS_CONFIRMED:
      return (
        <OwnerCurrentActionFooterContainer>
          <PingPongButton
            label={
              <FormattedMessage
                id='ui.ownerCurrentAction.adjustmentsConfirmeds.button'
                defaultMessage='Ajustements confirmés'
              />
            }
            type={PingPongButtonTypeEnum.PAYMENT_DONE}
          />
        </OwnerCurrentActionFooterContainer>
      )
    case ClientProposalOwnerActionEnum.CAN_CONTACT_ADMIN:
    case ClientProposalOwnerActionEnum.CAN_SEND_FEEDBACK:
      return (
        <OwnerCurrentActionFooterContainer>
          <PingPongButton
            label={
              <FormattedMessage
                id='ui.ownerCurrentAction.canContactAdmin.button'
                defaultMessage='Contacter votre conseiller Naboo'
              />
            }
            type={PingPongButtonTypeEnum.CONTACT_ADMIN}
            onClick={() =>
              window.open(`mailto:${clientRequest.adminCsm?.email}`)
            }
            dataTestId='contact-admin-button'
          />
        </OwnerCurrentActionFooterContainer>
      )
    // TODO : Uncomment this block when all feedbacks forms are ready
    /*
		case ClientProposalOwnerActionEnum.CAN_SEND_FEEDBACK:
      return (
        <OwnerCurrentActionFooterContainer>
          <PingPongButton
            type={PingPongButtonTypeEnum.GIVE_FEEDBACK}
            label={
              <FormattedMessage
                id='ui.ownerCurrentAction.GIVE_FEEDBACK.button'
                defaultMessage='Donnez votre avis sur le séjour'
              />
            }
            onClick={redirectRatingPage}
          />
        </OwnerCurrentActionFooterContainer>
      )
		*/
    default:
      return null
  }
}

export default OwnerCurrentAction
